import React, {useState, useEffect, useRef, createContext} from 'react';
import axios from 'axios';
import './KiraAI.css';
import styles from './../SwapMain.module.css';
import ChatMessage from './ChatMessage';
import LeftPanel from '../SwapLeftPanel/LeftPanel';
import ConnectWalletHeader from "../header/ConnectWalletHeader";
import {useContext} from 'react';
import {SwapMainAppContext} from '../../SwapMainAppContext';
import {fetchTokenBalances} from '../header/ConnectWalletHeaderOnchainHelper';
import KiraSwapMainAPP from '../KiraSwapMainApp.js';
import add_chat_icon from '../static_files/add_chat.svg';
import addChatIconHover from '../static_files/add_chat_hover.svg'
import {useIsMobile} from '../utils';

import mint_icon from '../static_files/kira chat mint.svg';
import redeem_icon from '../static_files/kira chat redeem.svg';
import c2c_icon from '../static_files/kira chat c2c.svg';
import send_icon from "../static_files/arrow-forward-long.svg"
import send_icon_hover from "../static_files/arrow-forward-long-hover.svg"
import kra_icon from '../static_files/KRA.svg';
import kra_mobile_icon from '../static_files/kra_icon_mobile.png'
import no_vip_icon from '../static_files/noVIP.svg';

import loadingImg from "../static_files/Loading1.svg";
import {useNavigate} from "react-router-dom";

// Backend URL for Kira AI
// const BACKEND_URL = 'http://127.0.0.1:8080';
const BACKEND_URL = 'https://kira-ai-256611876551.europe-west1.run.app/'
// const BACKEND_URL = 'https://kira-ai-256611876551.us-central1.run.app'


const KiraAI = () => {
    const inputRef = useRef(null);
    const isMobileScreen = useIsMobile(600);
    const [userClass, setUserClass] = useState(() => {
        return localStorage.getItem('userClass') || "";
    });
    const [hasVIPAccess, setHasVIPAccess] = useState(false);

    // Load messages from localStorage on initial render
    const [messages, setMessages] = useState(() => {
        const savedMessages = localStorage.getItem('kiraAIMessages');
        return savedMessages ? JSON.parse(savedMessages) : [];
    }); // current displaying messages
    const {
        conversations,
        setConversations,
        currentConversationId,
        setCurrentConversationId,
        selectedTab,
        setSelectedTab,
        selectedToken,
        setSelectedToken,
        typedMintValue,
        selectedPaymentMethod,
        showAddPayment,
        setShowAddPayment,
    } = useContext(SwapMainAppContext);

    const [isHovered, setIsHovered] = useState(false)
    const [sendIsHovered, setSendIsHovered] = useState(false)
    const isEmptyChat = messages.length === 0;

    const [loading, setLoading] = useState(false);
    const [conversationLoading, setConversationLoading] = useState(false);
    const [isInitialLoading, setIsInitialLoading] = useState(false);
    const [inputText, setInputText] = useState('');
    const messagesEndRef = useRef(null);
    const chatContainerRef = useRef(null);
    const [showPanel, setShowPanel] = useState(false);
    const [txTrigger, setTxTrigger] = useState(0);
    const [walletAddress, setWalletAddress] = useState(null);
    const [usdtBalance, setUsdtBalance] = useState(0);
    const [usdcBalance, setUsdcBalance] = useState(0);
    const [usdiBalance, setUsdiBalance] = useState(0);
    const [availableUSDI, setAvailableUSDI] = useState(null);
    const [confirmedAmount, setConfirmedAmount] = useState("0");
    const [isKiraAITransaction, setIsKiraAITransaction] = useState(false);
    const [isTransactionPending, setIsTransactionPending] = useState(false);
    const [isLeftPanelLoading, setIsLeftPanelLoading] = useState(false);

    // for SwapMainAPP overlay
    const [showSwapMainOverlay, setShowSwapMainOverlay] = useState(false);
    const [actionData, setActionData] = useState(null);
    const [isCloseButtonHover, setCloseButtonIsHover] = useState(false)
    const [isFinalData, setIsFinalData] = useState(false);
    const [shrinkLeftPanel, setShrinkLeftPanel] = useState(() => {
        const savedState = localStorage.getItem('shrinkLeftPanel');
        return savedState !== null ? JSON.parse(savedState) : false;
    });

    const kiraChatWidthShrink = shrinkLeftPanel ? '500' : '627.5';
    const handlePanelStateChange = (isPanelShrunk) => {
        setShrinkLeftPanel(isPanelShrunk);
    };

    // Now add the useEffect after all state declarations
    useEffect(() => {
        // Add debounced balance check
        const timeoutId = setTimeout(async () => {
            if (!typedMintValue || !walletAddress) return;

            const amount = parseFloat(typedMintValue);
            if (isNaN(amount) || amount <= 0) return;

            let balance = 0;
            let tokenName = '';

            if (selectedTab === 'mint') {
                if (selectedToken === 'USDT') {
                    balance = usdtBalance;
                    tokenName = 'USDT';
                } else if (selectedToken === 'USDC') {
                    balance = usdcBalance;
                    tokenName = 'USDC';
                }
            } else if (selectedTab === 'redeem') {
                balance = usdiBalance;
                tokenName = 'USDi';
            }

            if (amount > balance) {
                const message = `Insufficient ${tokenName} balance. You need ${amount} ${tokenName} but only have ${balance} ${tokenName}. Please add more ${tokenName} to your wallet.`;

                // Create system message object
                const systemMessage = {
                    id: Date.now(),
                    text: message,
                    sender: 'system',
                };

                // Add to messages state
                setMessages(prevMessages => [...prevMessages, systemMessage]);

                // Update conversations state
                setConversations(prev => prev.map(conv =>
                    conv.id === currentConversationId
                        ? {
                            ...conv,
                            messages: [...conv.messages, systemMessage],
                            lastMessage: systemMessage.text
                        }
                        : conv
                ));

                // Save to backend
                if (currentConversationId) {
                    try {
                        await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                            wallet_address: walletAddress,
                            conversation_id: currentConversationId,
                            message: message
                        });
                    } catch (error) {
                        console.error('Error saving balance warning message:', error);
                    }
                }
            } else {
                // User has sufficient balance
                const message = `Great! You can now ${selectedTab} ${amount} ${tokenName}.`;

                // Create system message object
                const systemMessage = {
                    id: Date.now(),
                    text: message,
                    sender: 'system',
                };

                // Add to messages state
                setMessages(prevMessages => [...prevMessages, systemMessage]);

                // Update conversations state
                setConversations(prev => prev.map(conv =>
                    conv.id === currentConversationId
                        ? {
                            ...conv,
                            messages: [...conv.messages, systemMessage],
                            lastMessage: systemMessage.text
                        }
                        : conv
                ));

                // Save to backend
                if (currentConversationId) {
                    try {
                        await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                            wallet_address: walletAddress,
                            conversation_id: currentConversationId,
                            message: message
                        });
                    } catch (error) {
                        console.error('Error saving balance confirmation message:', error);
                    }
                }
            }
        }, 750); // 0.5 second debounce

        return () => clearTimeout(timeoutId);
    }, [selectedTab, selectedToken, typedMintValue, selectedPaymentMethod, usdtBalance, usdcBalance, usdiBalance, walletAddress, currentConversationId]);

    // check if the user has vip
    useEffect(() => {
        setUserClass(localStorage.getItem('userClass'))
        if (walletAddress && userClass) {
            const words = userClass.split(' ');
            if (words.length > 1 && words[1] === 'VIP') {
                setHasVIPAccess(true);
            } else {
                setHasVIPAccess(false);
            }
        } else if (walletAddress) {
            setHasVIPAccess(false);
        }
    }, [walletAddress, userClass]);
    const navigate = useNavigate();

    const handleJoinVipClick = () => {
        navigate('/account');
    };
    // Save messages to localStorage whenever they change
    useEffect(() => {
        localStorage.setItem('kiraAIMessages', JSON.stringify(messages));
    }, [messages]);
    // Clear messages when wallet disconnects
    useEffect(() => {
        if (!walletAddress) {
            setMessages([]);
            setConversations([]);
            setCurrentConversationId(null);
            localStorage.removeItem('kiraAIMessages');
            localStorage.removeItem(`kira_conversations_${walletAddress}`);
            localStorage.removeItem('kiraCurrentConversationId');
        }
    }, [walletAddress]);


    const createNewChat = async () => {
        if (!hasVIPAccess) {
            return;
        }
        // Check if there are any conversations
        if (conversations.length > 0) {
            // Get the most recent conversation (first in the array)
            const mostRecentConversation = conversations[0];

            // Load the conversation to check if it's empty
            try {
                const response = await axios.get(`${BACKEND_URL}/api/conversation/${mostRecentConversation.id}`, {
                    params: {wallet_address: walletAddress}
                });

                // Check if it's empty and is a new chat
                if (response.data.messages.length === 0) {
                    // Just switch to this conversation instead of creating new one
                    setCurrentConversationId(mostRecentConversation.id);
                    setMessages([]);
                    return;
                }
            } catch (error) {
                console.error('Error checking conversation:', error);
            }
        }

        try {
            const response = await axios.post(`${BACKEND_URL}/api/new_conversation`, {
                wallet_address: walletAddress
            });

            const newConversation = {
                id: response.data.conversation_id,
                title: 'New Chat',
                lastMessage: null,
                messages: [] // Initialize empty messages array
            };

            setConversations(prev => [newConversation, ...prev]);
            setCurrentConversationId(newConversation.id);
            setMessages([]);

        } catch (error) {
            console.error('Error creating new chat:', error);
        }
    };

    const scrollToBottom = () => {
        // Only scroll the messages container, not the whole page
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({behavior: 'smooth', block: 'end'});
        }
    };
    const DEFAULT_TEXTAREA_HEIGHT = 25;
    useEffect(() => {
        // 切换聊天后清空输入框内容
        setInputText('');

        if (inputRef.current) {
            inputRef.current.style.height = `${DEFAULT_TEXTAREA_HEIGHT}px`;
        }
    }, [currentConversationId]);
    const autoGrow = (e) => {
        // 如果值为空，直接重置回 25px
        if (!e.target.value) {
            e.target.style.height = `${DEFAULT_TEXTAREA_HEIGHT}px`;
            return;
        }

        // 如果有内容，先重置为最小高度再设 scrollHeight
        e.target.style.height = `${DEFAULT_TEXTAREA_HEIGHT}px`;
        e.target.style.height = e.target.scrollHeight + "px";
    };
    // Function to close the SwapMainAPP overlay
    const handleCloseSwapMainOverlay = async () => {
        setShowSwapMainOverlay(false);
        setActionData(null);

        // Add a message when overlay is closed
        const message = "I see you've closed the transaction overlay. Let me know if you need anything else!";

        // Create system message object
        const systemMessage = {
            id: Date.now(),
            text: message,
            sender: 'system',
        };

        // Add to messages state
        setMessages(prevMessages => [...prevMessages, systemMessage]);

        // Update conversations state
        setConversations(prev => prev.map(conv =>
            conv.id === currentConversationId
                ? {
                    ...conv,
                    messages: [...conv.messages, systemMessage],
                    lastMessage: systemMessage.text
                }
                : conv
        ));

        // Save to backend
        if (currentConversationId) {
            try {
                await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                    wallet_address: walletAddress,
                    conversation_id: currentConversationId,
                    message: message
                });
            } catch (error) {
                console.error('Error saving overlay close message:', error);
            }
        }
    };

    // Handle transaction completion from SwapMainAPP
    const handleTransactionComplete = (success, details) => {
        setShowSwapMainOverlay(false);
        setActionData(null);

        // Add a message to the chat
        if (success) {
            window.createKiraAIMessage({
                text: `Transaction completed successfully! ${details || ''}`,
                sender: 'assistant'
            });
        } else {
            window.createKiraAIMessage({
                text: `Transaction could not be completed. ${details || 'Please try again later.'}`,
                sender: 'assistant'
            });
        }
    };


    useEffect(() => {
        if (messages.length > 0 || loading) {
            scrollToBottom();
        }
    }, [messages, loading]);

    useEffect(() => {
        console.log("input ref!!", inputRef.current)
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }, 100);
    }, [walletAddress]);
    const sendMessage = async (e) => {
        e.preventDefault();

        if (!inputText.trim()) return;

        // Clear input text immediately
        setInputText('');
        // After entering, the input will still be focused, so the user can keeps typing
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }, 100);

        // Check if the last message requires confirmation and if input is "YES"
        const lastMessage = messages[messages.length - 1];
        if (lastMessage?.requiresConfirmation && inputText.toUpperCase() === "YES") {
            // Create user confirmation message
            const userConfirmMessage = {
                id: Date.now(),
                text: inputText,
                sender: 'user',
                // timestamp: new Date().toISOString(),
            };

            // Add user's YES message
            setMessages(prevMessages => [...prevMessages, userConfirmMessage]);

            // Execute the pending action
            const {action, amount, token} = lastMessage.pendingAction;
            console.log("Executing action:", action, amount, token);

            // Create execution message
            const executionMessage = {
                id: Date.now() + 1,
                text: `Executing ${action} of ${amount} USDI with ${token}...`,
                sender: 'system',
                // timestamp: new Date().toISOString(),
            };

            // Add execution message
            setMessages(prevMessages => [...prevMessages, executionMessage]);

            // Update conversations with both messages
            setConversations(prev => prev.map(conv =>
                conv.id === currentConversationId
                    ? {
                        ...conv,
                        messages: [...conv.messages, userConfirmMessage, executionMessage],
                        lastMessage: executionMessage.text
                    }
                    : conv
            ));

            // Save both messages to backend
            await axios.post(`${BACKEND_URL}/api/add_user_message`, {
                wallet_address: walletAddress,
                conversation_id: currentConversationId,
                message: userConfirmMessage.text
            });

            await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                wallet_address: walletAddress,
                conversation_id: currentConversationId,
                message: executionMessage.text
            });

            // Set transaction details and trigger wallet header
            setConfirmedAmount(amount);
            setSelectedTab(action);
            setSelectedToken(token);
            setIsKiraAITransaction(true);
            setIsTransactionPending(true);
            setTxTrigger(prev => prev + 1);

            // Show transaction pending message
            const pendingMessage = {
                id: Date.now() + 2,
                text: "Please check your wallet to complete the transaction.",
                sender: 'system',
                // timestamp: new Date().toISOString(),
            };

            setMessages(prevMessages => [...prevMessages, pendingMessage]);
            setConversations(prev => prev.map(conv =>
                conv.id === currentConversationId
                    ? {
                        ...conv,
                        messages: [...conv.messages, pendingMessage],
                        lastMessage: pendingMessage.text
                    }
                    : conv
            ));

            return;
        }

        // Create user message first
        const userMessage = {
            id: Date.now(),
            text: inputText,
            sender: 'user',
            // timestamp: new Date().toISOString(),
        };

        let conversationId = currentConversationId;
        setLoading(true);

        // Update UI immediately with the user message
        setMessages(prevMessages => [...prevMessages, userMessage]);

        // Save to localStorage via useEffect
        localStorage.setItem('kiraAIMessages', JSON.stringify([userMessage]));


        // If no conversation exists, create one first
        if (!conversationId) {
            try {
                setConversationLoading(false);

                const response = await axios.post(`${BACKEND_URL}/api/new_conversation`, {
                    wallet_address: walletAddress
                });

                conversationId = response.data.conversation_id;
                const newConversation = {
                    id: conversationId,
                    title: 'New Chat',
                    lastMessage: null,
                    messages: [] // Initialize empty messages array
                };

                await axios.post(`${BACKEND_URL}/api/add_user_message`, {
                    wallet_address: walletAddress,
                    conversation_id: conversationId,
                    message: userMessage.text
                });

                setConversations(prev => [newConversation, ...prev]);
                setCurrentConversationId(conversationId);


            } catch (error) {
                console.error('Error creating new chat:', error);
                setLoading(false);
                return;
            }
        } else {
            // If conversation exists, update UI immediately
            await axios.post(`${BACKEND_URL}/api/add_user_message`, {
                wallet_address: walletAddress,
                conversation_id: conversationId,
                message: userMessage.text
            });


        }

        try {
            // Send message to Kira AI backend
            const startTime = Date.now();
            const response = await axios.post(`${BACKEND_URL}/api/query`, {
                query: inputText,
                wallet_address: walletAddress,
                conversation_id: conversationId,
                is_first_message: messages.length === 0,
                user_action_state: {
                    selectedTab,
                    selectedToken,
                    typedMintValue,
                    selectedPaymentMethod,
                }
            });
            const endTime = Date.now();

            const durationMs = endTime - startTime;
            console.log(`⏱️ KiraAI query took ${durationMs} ms`);

            // If it's the first message, update the conversation title
            if (messages.length === 0 && response.data.title) {
                setConversations(prev => prev.map(conv =>
                    conv.id === conversationId
                        ? {
                            ...conv,
                            title: response.data.title
                        }
                        : conv
                ));
            }

            // parse AI action msg
            // Extract AI response text
            console.log("AI Response:", response.data);
            const aiText = response.data.response || response.data.answer || response.data.message || response.data || "Sorry, I couldn't process that request.";

            // Check if the response contains an ACTION
            if (aiText.includes("[JSON]")) {
                if (!walletAddress) {
                    // Tell user to connect wallet if not connected
                    console.log("no wallet address")
                    const walletMessage = {
                        id: Date.now() + 1,
                        text: "Please connect your wallet first to proceed with the transaction.",
                        sender: 'system',
                        // timestamp: new Date().toISOString(),
                    };
                    setMessages(prevMessages => [...prevMessages, walletMessage]);

                    // Add to conversations
                    setConversations(prev => prev.map(conv =>
                        conv.id === conversationId
                            ? {
                                ...conv,
                                messages: [...conv.messages, walletMessage],
                                lastMessage: walletMessage.text
                            }
                            : conv
                    ));

                    await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                        wallet_address: walletAddress,
                        conversation_id: conversationId,
                        message: walletMessage.text
                    });
                    return;
                }
                const actionJsonString = aiText.replace("[JSON]", "").trim();
                const actionData = JSON.parse(actionJsonString);
                setActionData({
                    action: actionData.action, // Default to current tab
                    amount: actionData.amount, // @Chloe Todo : change to actual amount
                    token: actionData.token // @Chloe Todo : change to actual token
                });
                console.log("actionData", actionData);
                setShowSwapMainOverlay(true);
                const aiMessage = {
                    id: Date.now() + 1,
                    text: "I've opened the transaction interface for you. Please check everything is correct and complete your transaction there.",
                    sender: 'ai',
                };

                await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                    wallet_address: walletAddress,
                    conversation_id: conversationId,
                    message: aiMessage.text
                });

                setMessages(prevMessages => [...prevMessages, aiMessage]);
                setConversations(prev => prev.map(conv =>
                    conv.id === conversationId
                        ? {
                            ...conv,
                            messages: [...(conv.messages || []), aiMessage],
                            lastMessage: aiMessage.text
                        }
                        : conv
                ));

                setLoading(false);
                return;
            }
            // old json parsing
            if (aiText.startsWith("[JSON]")) {
                const actionJsonString = aiText.replace("[JSON]", "").trim();

                try {
                    const actionData = JSON.parse(actionJsonString);
                    console.log("Parsed Action Data:", actionData);
                    if (actionData.action === "mint" || actionData.action === "redeem") {
                        console.log("walletAddress:", walletAddress);
                        console.log("actionData", actionData.action, actionData.token, actionData.amount);
                        console.log("usdtBalance", usdtBalance);
                        console.log("usdcBalance", usdcBalance);
                        if (!walletAddress) {
                            // Tell user to connect wallet if not connected
                            console.log("no wallet address")
                            const walletMessage = {
                                id: Date.now() + 1,
                                text: "Please connect your wallet first to proceed with the transaction.",
                                sender: 'system',
                                // timestamp: new Date().toISOString(),
                            };
                            setMessages(prevMessages => [...prevMessages, walletMessage]);

                            // Add to conversations
                            setConversations(prev => prev.map(conv =>
                                conv.id === conversationId
                                    ? {
                                        ...conv,
                                        messages: [...conv.messages, walletMessage],
                                        lastMessage: walletMessage.text
                                    }
                                    : conv
                            ));
                            return;
                        }
                        var mintBalance = 0;

                        if (actionData.action === "mint" && actionData.token === "USDT") {
                            mintBalance = usdtBalance;

                        } else if (actionData.action === "mint" && actionData.token === "USDC") {
                            mintBalance = usdcBalance;
                        }

                        setLoading(false);

                        if (actionData.action === "redeem" && actionData.amount > availableUSDI) {
                            const errorMessage = {
                                id: Date.now() + 1,
                                text: `I'm sorry, but you don't have enough USDI to complete this transaction. Do you want me to help you mint more USDI?`,
                                sender: 'ai',
                                // timestamp: new Date().toISOString(),
                            };

                            setLoading(false);
                            // Add  error message
                            setMessages(prevMessages => [...prevMessages, errorMessage]);

                            // Update conversations state
                            setConversations(prev => prev.map(conv =>
                                conv.id === conversationId
                                    ? {
                                        ...conv,
                                        messages: [...conv.messages, errorMessage],
                                        lastMessage: errorMessage.text
                                    }
                                    : conv
                            ));

                            setLoading(false);

                            await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                                wallet_address: walletAddress,
                                conversation_id: conversationId,
                                message: errorMessage.text
                            });

                            return;
                        } else if (actionData.action === "mint" && mintBalance < actionData.amount) {
                            console.log("mintBalance", mintBalance);
                            console.log("actionData.amount", actionData.amount);
                            const errorMessage = {
                                id: Date.now() + 1,
                                text: `I'm sorry, but you don't have enough ${actionData.token} to complete this transaction. Please try again with a smaller amount.`,
                                sender: 'ai',
                            };

                            // Add error message
                            setMessages(prevMessages => [...prevMessages, errorMessage]);

                            // Update conversations state
                            setConversations(prev => prev.map(conv =>
                                conv.id === conversationId
                                    ? {
                                        ...conv,
                                        messages: [...conv.messages, errorMessage],
                                        lastMessage: errorMessage.text
                                    }
                                    : conv
                            ));

                            await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                                wallet_address: walletAddress,
                                conversation_id: conversationId,
                                message: errorMessage.text
                            });

                            setLoading(false); // Reset loading state before returning
                            return;
                        }

                        // Add confirmation message and record it in history
                        const confirmationText = `I'll help you ${actionData.action} ${actionData.amount} USDI with ${actionData.token}. Please reply 'YES' to confirm this action.`;

                        // Create confirmation message object
                        const confirmationMessage = {
                            id: Date.now() + 1,
                            text: confirmationText,
                            sender: 'ai',
                            // timestamp: new Date().toISOString(),
                            requiresConfirmation: true,
                            pendingAction: {
                                action: actionData.action,
                                amount: actionData.amount,
                                token: actionData.token
                            }
                        };

                        // Add to messages state
                        setMessages(prevMessages => [...prevMessages, confirmationMessage]);

                        // Add to conversations state
                        setConversations(prev => prev.map(conv =>
                            conv.id === conversationId
                                ? {
                                    ...conv,
                                    messages: [...conv.messages, confirmationMessage],
                                    lastMessage: confirmationMessage.text
                                }
                                : conv
                        ));

                        setLoading(false); // Reset loading state before returning

                        // Record system confirmation message to backend
                        await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                            wallet_address: walletAddress,
                            conversation_id: conversationId,
                            message: confirmationText
                        });

                        // Update localStorage for conversations
                        localStorage.setItem(
                            `kira_conversations_${walletAddress}`,
                            JSON.stringify(conversations)
                        );


                        return;
                    }
                } catch (parseError) {
                    console.error("Error parsing AI action response:", parseError);
                }
            }

            // Add AI response to chat
            const aiMessage = {
                id: Date.now() + 1,
                text: response.data.response || response.data.answer || response.data.message || response.data || "Sorry, I couldn't process that request.",
                sender: 'ai',
            };

            setMessages(prevMessages => [...prevMessages, aiMessage]);
            setConversations(prev => prev.map(conv =>
                conv.id === conversationId
                    ? {
                        ...conv,
                        messages: [...(conv.messages || []), aiMessage],
                        lastMessage: aiMessage.text
                    }
                    : conv
            ));

            // Update localStorage
            localStorage.setItem(
                `kira_conversations_${walletAddress}`,
                JSON.stringify(conversations)
            );


            // Check if AI message is "ACTION" and trigger transaction
            if (aiMessage.text.includes("ACTION")) {
                console.log("ACTION")
                // @ TODO: implement checking wallet address, if wallet address not found, ai tell user to connect wallet first
                setTxTrigger(prev => prev + 1);
            }
        } catch (error) {
            console.error('Error sending message to Kira AI:', error);

            // Add error message
            const errorMessage = {
                id: Date.now() + 1,
                text: "Sorry, I couldn't connect to the server. Please try again later.",
                sender: 'system',
                // timestamp: new Date().toISOString(),
            };

            setMessages(prevMessages => [...prevMessages, errorMessage]);
            await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                wallet_address: walletAddress,
                conversation_id: conversationId,
                message: errorMessage.text
            });
        } finally {
            setLoading(false);
        }
    };

    const loadConversation = async (conversationId) => {
        if (!walletAddress) return;  // Early return if no wallet

        try {
            // setConversationLoading(true);
            // Clear existing messages first
            setConversationLoading(true);
            setMessages([]);


            const response = await axios.get(`${BACKEND_URL}/api/conversation/${conversationId}`, {
                params: {wallet_address: walletAddress}
            });

            const formattedMessages = response.data.messages.map(msg => ({
                id: Date.now() + Math.random(), // Add unique ID for each message
                text: msg.content,
                sender: msg.role === 'user' ? 'user' : 'assistant',
                // timestamp: new Date().toISOString()
            }));

            setMessages(formattedMessages);

            setConversations(prev => prev.map(conv =>
                conv.id === conversationId
                    ? {
                        ...conv,
                        id: response.data.id,
                        messages: formattedMessages,
                        lastMessage: response.data.lastMessage,
                    }
                    : conv
            ));
        } catch (error) {
            console.error('Error loading conversation:', error);
        } finally {
            setConversationLoading(false);
        }
    };

    // Function to clear chat history
    const clearChat = () => {
        setMessages([]);
        localStorage.removeItem('kiraAIMessages');
    };

    // Modify the useEffect that watches currentConversationId
    useEffect(() => {
        if (currentConversationId && walletAddress) {  // Add walletAddress check
            loadConversation(currentConversationId);
        }
    }, [currentConversationId, walletAddress]);  // Add walletAddress as dependency

    // Add this useEffect to create the global function
    useEffect(() => {
        // Create the global function for adding messages
        window.createKiraAIMessage = async (messageData) => {
            const newMessage = {
                id: Date.now(),
                text: messageData.content || messageData.text,
                sender: messageData.role || messageData.sender,
                // timestamp: new Date().toISOString(),
            };

            setMessages(prevMessages => {
                const updatedMessages = [...prevMessages, newMessage];
                // Save to localStorage
                localStorage.setItem('kiraAIMessages', JSON.stringify(updatedMessages));
                return updatedMessages;
            });

            setIsTransactionPending(false);
            // If this is part of a conversation, update the conversation's messages
            if (currentConversationId) {
                setConversations(prev => prev.map(conv =>
                    conv.id === currentConversationId
                        ? {
                            ...conv,
                            messages: [...conv.messages, newMessage],
                            lastMessage: newMessage.text
                        }
                        : conv
                ));

                // Send to backend
                try {
                    await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                        wallet_address: walletAddress,
                        conversation_id: currentConversationId,
                        message: newMessage.text
                    });
                } catch (error) {
                    console.error('Error sending message to backend:', error);
                }
            }
        };

        // Cleanup function to remove the global function when component unmounts
        return () => {
            delete window.createKiraAIMessage;
        };
    }, [currentConversationId, walletAddress]); // Add dependencies

    const handleMintButtonClick = async () => {
        try {
            // Create user message
            const userMessage = {
                id: Date.now(),
                text: "I want to mint USDI",
                sender: 'user',
                // timestamp: new Date().toISOString()
            };

            let conversationId = currentConversationId;

            // If no conversation exists, create one first
            if (!conversationId) {
                const response = await axios.post(`${BACKEND_URL}/api/new_conversation`, {
                    wallet_address: walletAddress
                });

                conversationId = response.data.conversation_id;
                const newConversation = {
                    id: conversationId,
                    title: 'New Chat',
                    lastMessage: null,
                    messages: [] // Initialize empty messages array
                };

                setConversations(prev => [newConversation, ...prev]);
                setCurrentConversationId(conversationId);
            }

            // Add user message first and show thinking state
            setMessages(prevMessages => [...prevMessages, userMessage]);
            setLoading(true);

            // Update conversations with user message first
            setConversations(prev => prev.map(conv =>
                conv.id === conversationId
                    ? {
                        ...conv,
                        messages: [...(conv.messages || []), userMessage],
                        lastMessage: userMessage.text
                    }
                    : conv
            ));

            // Save user message to backend
            await axios.post(`${BACKEND_URL}/api/add_user_message`, {
                wallet_address: walletAddress,
                conversation_id: conversationId,
                message: userMessage.text
            });

            // Delay AI response by 500ms
            await new Promise(resolve => setTimeout(resolve, 500));

            // Create AI response
            const aiMessage = {
                id: Date.now() + 1,
                text: "Please specify how many USDI and what token (USDT or USDC)",
                sender: 'assistant',
                // timestamp: new Date().toISOString()
            };

            // Save AI message to backend first
            await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                wallet_address: walletAddress,
                conversation_id: conversationId,
                message: aiMessage.text
            });

            // Add AI message and stop loading state
            setMessages(prevMessages => [...prevMessages, aiMessage]);
            setLoading(false);

            // Update conversations with both messages
            setConversations(prev => prev.map(conv =>
                conv.id === conversationId
                    ? {
                        ...conv,
                        messages: [...(conv.messages || []), aiMessage],
                        lastMessage: aiMessage.text
                    }
                    : conv
            ));

            // Save to localStorage
            localStorage.setItem('kiraAIMessages', JSON.stringify([...messages, userMessage, aiMessage]));
            localStorage.setItem(`kira_conversations_${walletAddress}`, JSON.stringify(conversations));

        } catch (error) {
            console.error('Error in handleMintButtonClick:', error);
            setLoading(false);
        }
    };

    const handleRedeemButtonClick = async () => {
        const userMessage = {
            id: Date.now(),
            text: "I want to redeem USDI",
            sender: 'user',
            // timestamp: new Date().toISOString(),
        };

        if (currentConversationId === null) {
            await createNewChat();
        }

        setMessages(prevMessages => [...prevMessages, userMessage]);
        setLoading(true);

        await axios.post(`${BACKEND_URL}/api/add_user_message`, {
            wallet_address: walletAddress,
            conversation_id: currentConversationId,
            message: userMessage.text
        });

        setConversations(prev => prev.map(conv =>
            conv.id === currentConversationId
                ? {
                    ...conv,
                    messages: [...conv.messages, userMessage],
                    lastMessage: userMessage.text
                }
                : conv
        ));

        await new Promise(resolve => setTimeout(resolve, 500));

        const aiMessage = {
            id: Date.now() + 1,
            text: "Please specify how many USDI you want to redeem",
            sender: 'assistant',
            // timestamp: new Date().toISOString(),
        };

        await axios.post(`${BACKEND_URL}/api/add_system_message`, {
            wallet_address: walletAddress,
            conversation_id: currentConversationId,
            message: aiMessage.text
        });

        setMessages(prevMessages => [...prevMessages, aiMessage]);
        setConversations(prev => prev.map(conv =>
            conv.id === currentConversationId
                ? {
                    ...conv,
                    messages: [...conv.messages, aiMessage],
                    lastMessage: aiMessage.text
                }
                : conv
        ));

        setLoading(false);


        // Rest of the code similar to mint function...
    };

    const handleNetworkButtonClick = async () => {
        // Create user message
        const userMessage = {
            id: Date.now(),
            text: "I want to exchange USDI with c2c network",
            sender: 'user',
            // timestamp: new Date().toISOString(),
        };

        // Create AI response
        const aiMessage = {
            id: Date.now() + 1,
            text: "This feature is not available yet. Please use the c2c network under My Assets tab for now.",
            sender: 'assistant',
            // timestamp: new Date().toISOString(),
        };

        // If no conversation exists, create one
        if (currentConversationId === null) {
            await createNewChat();
        }
        // Add both messages to state
        setMessages(prevMessages => [...prevMessages, userMessage, aiMessage]);

        setConversations(prev => prev.map(conv =>
            conv.id === currentConversationId
                ? {
                    ...conv,
                    messages: [...conv.messages, userMessage, aiMessage],
                    lastMessage: aiMessage.text
                }
                : conv
        ));
        // Save user message to backend
        await axios.post(`${BACKEND_URL}/api/add_user_message`, {
            wallet_address: walletAddress,
            conversation_id: currentConversationId,
            message: userMessage.text
        });

        // Save AI message to backend
        await axios.post(`${BACKEND_URL}/api/add_system_message`, {
            wallet_address: walletAddress,
            conversation_id: currentConversationId,
            message: aiMessage.text
        });

        // Update localStorage
        localStorage.setItem(
            `kira_conversations_${walletAddress}`,
            JSON.stringify(conversations)
        );
    };
    useEffect(() => {
        // Only check balance if overlay is open and we have a wallet
        console.log("showSwapMainOverlay", showSwapMainOverlay);
        console.log("Action Data 3:", actionData);

        if (showSwapMainOverlay && walletAddress && actionData) {
            const checkBalance = async () => {
                console.log('Current transaction state:', {
                    action: actionData.action,
                    token: actionData.token,
                    amount: actionData.amount
                });

                let hasEnoughBalance = true;
                let errorMessage = '';

                if (actionData.action === 'mint') {
                    const requiredBalance = parseFloat(actionData.amount) || 0;
                    if (actionData.token === 'USDT' && usdtBalance < requiredBalance) {
                        hasEnoughBalance = false;
                        errorMessage = `You don't have enough USDT balance. Your current balance is ${usdtBalance} USDT. Please try a smaller amount.`;
                    } else if (actionData.token === 'USDC' && usdcBalance < requiredBalance) {
                        hasEnoughBalance = false;
                        errorMessage = `You don't have enough USDC balance. Your current balance is ${usdcBalance} USDC. Please try a smaller amount.`;
                    }
                } else if (actionData.action === 'redeem') {
                    const requiredBalance = parseFloat(actionData.amount) || 0;
                    if (usdiBalance < requiredBalance) {
                        hasEnoughBalance = false;
                        errorMessage = `You don't have enough USDI balance. Your current balance is ${usdiBalance} USDI. Please try a smaller amount.`;
                    }
                }

                if (!hasEnoughBalance) {
                    console.log("errorMessage not enough balance", errorMessage);
                    const systemMessage = {
                        id: Date.now(),
                        text: errorMessage,
                        sender: 'system',
                    };

                    setMessages(prevMessages => [...prevMessages, systemMessage]);
                    setConversations(prev => prev.map(conv =>
                        conv.id === currentConversationId
                            ? {
                                ...conv,
                                messages: [...conv.messages, systemMessage],
                                lastMessage: systemMessage.text
                            }
                            : conv
                    ));

                    // Save to backend
                    if (currentConversationId) {
                        try {
                            await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                                wallet_address: walletAddress,
                                conversation_id: currentConversationId,
                                message: errorMessage
                            });
                        } catch (error) {
                            console.error('Error saving balance warning message:', error);
                        }
                    }
                }
            };

            checkBalance();
        }
    }, [showSwapMainOverlay, walletAddress, usdtBalance, usdcBalance, usdiBalance, currentConversationId, actionData]);
    const placeholderStyle = {
        color: !hasVIPAccess ? 'white' : 'inherit'
    };
    const sendMessageStreaming = async (e) => {
        e.preventDefault();

        if (!inputText.trim()) return;

        // Clear input text immediately
        setInputText('');

        // Create user message first
        const userMessage = {
            id: Date.now(),
            text: inputText,
            sender: 'user',
        };

        let conversationId = currentConversationId;
        setLoading(true);

        // Update UI immediately with the user message
        setMessages(prevMessages => [...prevMessages, userMessage]);

        // Save to localStorage via useEffect
        localStorage.setItem('kiraAIMessages', JSON.stringify([userMessage]));

        // If no conversation exists, create one first
        if (!conversationId) {
            try {
                setConversationLoading(false);
                const response = await axios.post(`${BACKEND_URL}/api/new_conversation`, {
                    wallet_address: walletAddress
                });

                conversationId = response.data.conversation_id;
                const newConversation = {
                    id: conversationId,
                    title: 'New Chat',
                    lastMessage: null,
                    messages: []
                };

                await axios.post(`${BACKEND_URL}/api/add_user_message`, {
                    wallet_address: walletAddress,
                    conversation_id: conversationId,
                    message: userMessage.text
                });

                setConversations(prev => [newConversation, ...prev]);
                setCurrentConversationId(conversationId);
            } catch (error) {
                console.error('Error creating new chat:', error);
                setLoading(false);
                return;
            }
        } else {
            // If conversation exists, update UI immediately
            await axios.post(`${BACKEND_URL}/api/add_user_message`, {
                wallet_address: walletAddress,
                conversation_id: conversationId,
                message: userMessage.text
            });
        }

        try {
            // Create a temporary message for streaming
            const tempMessage = {
                id: Date.now() + 1,
                text: '',
                sender: 'ai',
                isStreaming: true,
                intermediateText: '',
                finalText: ''
            };
            setMessages(prevMessages => [...prevMessages, tempMessage]);

            // Send message to Kira AI backend with streaming
            const response = await fetch(`${BACKEND_URL}/api/query/stream`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    query: inputText,
                    wallet_address: walletAddress,
                    conversation_id: conversationId,
                    is_first_message: messages.length === 0,
                    user_action_state: {
                        selectedTab,
                        selectedToken,
                        typedMintValue,
                        selectedPaymentMethod,
                    }
                })
            });

            const reader = response.body.getReader();
            let accumulatedText = '';
            let finalResponse = '';
            let isFinalDataVar = false;
            setIsFinalData(false);


            while (true) {
                const {done, value} = await reader.read();
                if (done) break;

                // Convert the chunk to text
                const chunk = new TextDecoder().decode(value);
                console.log('Raw chunk from backend:', chunk);


                // Check if this is the final data marker
                if (chunk.includes('[final data]')) {
                    console.log('Found final data marker');
                    isFinalDataVar = true;
                    setIsFinalData(true);


                    if (chunk.includes("[JSON]")) {
                        try {
                            console.log('Found JSON in final data');
                            if (!walletAddress) {
                                // Tell user to connect wallet if not connected
                                console.log("no wallet address")
                                const walletMessage = {
                                    id: Date.now() + 1,
                                    text: "Please connect your wallet first to proceed with the transaction.",
                                    sender: 'system',
                                    // timestamp: new Date().toISOString(),
                                };
                                setMessages(prevMessages => [...prevMessages, walletMessage]);

                                // Add to conversations
                                setConversations(prev => prev.map(conv =>
                                    conv.id === conversationId
                                        ? {
                                            ...conv,
                                            messages: [...conv.messages, walletMessage],
                                            lastMessage: walletMessage.text
                                        }
                                        : conv
                                ));

                                await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                                    wallet_address: walletAddress,
                                    conversation_id: conversationId,
                                    message: walletMessage.text
                                });
                                return;
                            }
                            const actionJsonString = chunk.replace("[JSON]", "").replace("[END]", "").replace("[final data]", "").trim();
                            console.log("actionJsonString", actionJsonString);
                            const actionData = JSON.parse(actionJsonString);
                            setActionData({
                                action: actionData.action, // Default to current tab
                                amount: actionData.amount, // @Chloe Todo : change to actual amount
                                token: actionData.token // @Chloe Todo : change to actual token
                            });
                            console.log("actionData", actionData);
                            setShowSwapMainOverlay(true);
                            const aiMessage = {
                                id: Date.now() + 1,
                                text: "I've opened the transaction interface for you. Please check everything is correct and complete your transaction there.",
                                sender: 'ai',
                            };


                            await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                                wallet_address: walletAddress,
                                conversation_id: conversationId,
                                message: aiMessage.text
                            });

                            setMessages(prevMessages => [...prevMessages, aiMessage]);
                            setConversations(prev => prev.map(conv =>
                                conv.id === conversationId
                                    ? {
                                        ...conv,
                                        messages: [...(conv.messages || []), aiMessage],
                                        lastMessage: aiMessage.text
                                    }
                                    : conv
                            ));

                            setLoading(false);
                            return;
                        } catch (error) {
                            setShowSwapMainOverlay(true);

                            console.error("Error parsing AI action response:", error);
                            const aiMessage = {
                                id: Date.now() + 1,
                                text: "I've opened the transaction interface for you. Please check everything is correct and complete your transaction there.",
                                sender: 'ai',
                            };

                            await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                                wallet_address: walletAddress,
                                conversation_id: conversationId,
                                message: aiMessage.text
                            });

                            setMessages(prevMessages => [...prevMessages, aiMessage]);
                            setConversations(prev => prev.map(conv =>
                                conv.id === conversationId
                                    ? {
                                        ...conv,
                                        messages: [...(conv.messages || []), aiMessage],
                                        lastMessage: aiMessage.text
                                    }
                                    : conv
                            ));

                            setLoading(false);
                            return;
                        }

                    } else if (chunk.includes("[INFO NEEDED]")) {
                        console.log('Found INFO NEEDED in final data');
                        const infoMessage = chunk
                            .replace("[INFO NEEDED]", "")
                            .replace("[END]", "")
                            .replace("[final data]", "")
                            .trim();

                        console.log("Info message:", infoMessage);

                        const aiMessage = {
                            id: Date.now() + 1,
                            text: infoMessage,
                            sender: 'ai',
                        };

                        setMessages(prevMessages => [...prevMessages, aiMessage]);
                        setConversations(prev => prev.map(conv =>
                            conv.id === conversationId
                                ? {
                                    ...conv,
                                    messages: [...(conv.messages || []), aiMessage],
                                    lastMessage: aiMessage.text
                                }
                                : conv
                        ));

                        if (walletAddress && conversationId) {
                            await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                                wallet_address: walletAddress,
                                conversation_id: conversationId,
                                message: infoMessage
                            });
                        }

                        setLoading(false);
                        return;
                    }
                    continue;
                }

                // Remove the "data: " prefix but preserve spaces and newlines
                const cleanChunk = chunk.replace(/^data: /, '');
                console.log('Cleaned chunk:', cleanChunk);

                if (isFinalDataVar) {
                    // For final data, accumulate directly
                    finalResponse += cleanChunk;

                    // Update the message with both intermediate and final text
                    setMessages(prevMessages =>
                        prevMessages.map(msg =>
                            msg.id === tempMessage.id
                                ? {
                                    ...msg,
                                    intermediateText: accumulatedText,
                                    finalText: finalResponse.replace('[END]', ''),
                                    isStreaming: false,
                                    text: finalResponse.replace('[END]', '')
                                }
                                : msg
                        )
                    );
                } else {
                    // For intermediate text, add vertical line prefix to each line
                    if (cleanChunk) {
                        const lines = cleanChunk.split('\n');
                        const formattedLines = lines.map(line => line).join('\n');
                        accumulatedText += formattedLines;

                        // Update only the intermediate text
                        setMessages(prevMessages =>
                            prevMessages.map(msg =>
                                msg.id === tempMessage.id
                                    ? {...msg, intermediateText: accumulatedText}
                                    : msg
                            )
                        );
                    }
                }
            }

            // Handle any remaining final response content
            if (finalResponse) {
                setMessages(prevMessages =>
                    prevMessages.map(msg =>
                        msg.id === tempMessage.id
                            ? {
                                ...msg,
                                intermediateText: accumulatedText,
                                finalText: finalResponse.replace('[END]', ''),
                                isStreaming: false,
                                text: finalResponse.replace('[END]', '')
                            }
                            : msg
                    )
                );
            }

            // // Handle any JSON actions in the final response
            // console.log('Final response:', finalResponse);
            // if (finalResponse.includes("[JSON]")) {
            //     const actionJsonString = finalResponse.replace("[JSON]", "").trim();
            //     try {
            //         const actionData = JSON.parse(actionJsonString);
            //         if (actionData.action === "mint" || actionData.action === "redeem") {
            //             if (!walletAddress) {
            //                 const walletMessage = {
            //                     id: Date.now() + 2,
            //                     text: "Please connect your wallet first to proceed with the transaction.",
            //                     sender: 'system',
            //                 };
            //                 setMessages(prevMessages => [...prevMessages, walletMessage]);
            //                 return;
            //             }

            //             setActionData({
            //                 action: actionData.action,
            //                 amount: actionData.amount,
            //                 token: actionData.token
            //             });
            //             setShowSwapMainOverlay(true);
            //         }
            //     } catch (parseError) {
            //         console.error("Error parsing AI action response:", parseError);
            //     }
            // }

            // Update conversations with the final message
            setConversations(prev => prev.map(conv =>
                conv.id === conversationId
                    ? {
                        ...conv,
                        messages: [...conv.messages, {
                            ...tempMessage,
                            text: finalResponse.replace('[END]', ''),
                            isStreaming: false
                        }],
                        lastMessage: finalResponse.replace('[END]', '')
                    }
                    : conv
            ));

            // Save the final message to backend
            await axios.post(`${BACKEND_URL}/api/add_system_message`, {
                wallet_address: walletAddress,
                conversation_id: conversationId,
                message: finalResponse.replace('[END]', '')
            });

        } catch (error) {
            console.error('Error in streaming response:', error);
            const errorMessage = {
                id: Date.now() + 1,
                text: "Sorry, I couldn't connect to the server. Please try again later.",
                sender: 'system',
            };
            setMessages(prevMessages => [...prevMessages, errorMessage]);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.outerContainer} style={{width: '100vw'}}>
            {/* SwapMainAPP Side Panel */}
            {showSwapMainOverlay && (
                <div className="swap-main-side-panel" style={{
                    width: '35%',
                    height: '100vh',
                    position: 'fixed',
                    right: 0,
                    top: 0,
                    backgroundColor: '#04070D',
                    borderLeft: '1px solid rgba(255, 255, 255, 0.1)',
                    overflow: 'auto',
                    zIndex: 1000,
                    minWidth: '480px'
                }}>
                    <div style={{
                        position: 'absolute',
                        top: '20px',
                        right: '20px',
                        zIndex: 1001,
                        backgroundColor: 'transparent'
                    }}>
                        <button
                            onClick={handleCloseSwapMainOverlay}
                            onMouseEnter={() => setCloseButtonIsHover(true)}
                            onMouseLeave={() => setCloseButtonIsHover(false)}
                            style={{
                                backgroundColor: 'transparent',
                                border: 'none',
                                color: isCloseButtonHover ? 'grey' : 'white',
                                fontSize: '24px',
                                cursor: 'pointer'
                            }}
                        >
                            ✕
                        </button>
                    </div>
                    <KiraSwapMainAPP
                        initialTab={actionData?.action}
                        initialToken={actionData?.token}
                        initialAmount={actionData?.amount?.toString()}
                        onTransactionComplete={handleTransactionComplete}
                        isFromKiraAI={true}
                        key={`transaction-${actionData?.action}-${actionData?.token}-${actionData?.amount}`}
                    />
                </div>
            )}
            <div className="kira-ai-container" style={{
                // display: 'flex',
                // flexDirection: 'row',
                // width: '100%',
                // height: '100vh',
                // transition: 'all 0.3s ease',
                // position: 'relative',
                // zIndex: 1
            }}>
                <LeftPanel
                    walletAddress={walletAddress}
                    onLoadingChange={setIsLeftPanelLoading}
                    isAutoShrink={showSwapMainOverlay}
                    onPanelStateChange={handlePanelStateChange}
                />

                <div style={{
                    width: showSwapMainOverlay ? `min(59%, calc(100% - ${kiraChatWidthShrink}px))` : '100%',
                    transition: 'width 0.3s ease'
                }}>

                    <div className={`chat-main-area`}>
                        {!showSwapMainOverlay && <ConnectWalletHeader
                            amount={confirmedAmount}
                            transactionType={selectedTab}
                            transactionTrigger={txTrigger}
                            toAddress="4dJ5ATt3BbJPrbYCZGLAXndi5DPaZZY9j1Sp8Hdh4ApH"
                            selectedToken={selectedToken}
                            selectedPaymentId={null}
                            selectedPaymentMethod={null}
                            onWalletConnected={(publicKey, usdtLeft, usdcLeft, usdiLeft) => {
                                setWalletAddress(publicKey);
                                setUsdtBalance(usdtLeft);
                                setUsdcBalance(usdcLeft);
                                setUsdiBalance(usdiLeft);
                                setAvailableUSDI(usdiLeft)
                            }}
                            transactionTime={null}
                            showPanel={showPanel}
                            setShowPanel={setShowPanel}
                            onTransactionComplete={(success, error) => {
                                setIsTransactionPending(false);
                                if (success) {
                                    window.createKiraAIMessage({
                                        text: "Transaction completed successfully! Is there anything else I can help you with?",
                                        sender: 'assistant'
                                    });
                                } else {
                                    setIsTransactionPending(false);
                                    window.createKiraAIMessage({
                                        text: `I encountered an error while processing your transaction: ${error}. Would you like me to help you understand what went wrong?`,
                                        sender: 'assistant'
                                    });
                                }
                            }}
                            onTransactionError={(error) => {
                                setIsTransactionPending(false);
                            }}
                            isKiraAITransaction={isKiraAITransaction}
                            isKiraAIPage={true} // to set some styling
                        />}
                        <div className="new-chat-button-outer-container">
                            <div className="new-chat-button-container">
                                {hasVIPAccess && (
                                    <button
                                        className="new-chat-button"
                                        onClick={createNewChat}
                                        disabled={!walletAddress}
                                        style={{
                                            opacity: !walletAddress ? 0.5 : 1,
                                            top: showSwapMainOverlay ? '-5.5px' : '-106px'
                                        }}
                                        onMouseEnter={() => setIsHovered(true)}
                                        onMouseLeave={() => setIsHovered(false)}
                                    >
                                        <img
                                            src={isHovered ? addChatIconHover : add_chat_icon}
                                            alt="+"
                                            style={{marginRight: 8}}
                                        />
                                        New chat
                                    </button>
                                )}
                            </div>
                        </div>
                        <div
                            className={`chat-messages-outer-container ${isEmptyChat ? 'chat-messages-outer-container-new-chat' : ''}`}
                            style={{
                                height: isEmptyChat ? 'calc(29vh + 80px)' : (showSwapMainOverlay ? 'calc(100vh -318px)' : 'calc(100vh - 292px)'),
                                marginTop: showSwapMainOverlay ? '94px' : '0px',
                            }}
                        >
                            <div className="chat-messages-container" ref={chatContainerRef}
                                 style={{
                                     paddingTop: isEmptyChat ? "104px" : 'inherit',
                                     paddingBottom: isEmptyChat ? "0px" : 'inherit',

                                 }}
                            >
                                {isInitialLoading ? (
                                    <div className="empty-chat">
                                        <div className="welcome-container">
                                            {/*<img className="LoadingImage" style={{height:"40px", width:"40px"}} src={loadingImg} alt="Loading"/>*/}
                                            <div className="loading-spinner"></div>
                                        </div>
                                    </div>
                                ) : conversationLoading ? (
                                    <div className="empty-chat">
                                        <div className="welcome-container">
                                            {/*<img className="LoadingImage" style={{height:"40px", width:"40px"}}  src={loadingImg} alt="Loading"/>*/}
                                            <div className="loading-spinner"></div>

                                        </div>
                                    </div>
                                ) : messages.length === 0 ? (
                                    <div className="empty-chat">
                                        <div className="welcome-container">
                                            {isMobileScreen ? <div className="kira-avatar-large"
                                                                   style={{display: 'flex', flexDirection: 'column'}}>
                                                <img src={kra_mobile_icon} alt="Kira" onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = 'https://via.placeholder.com/100'
                                                }}
                                                     style={{
                                                         borderRadius: '50%',
                                                         objectFit: 'cover',
                                                         marginBottom: "16px"
                                                     }}
                                                />
                                                <h3 className="welcome-heading">I'm Kira</h3>

                                            </div> : <div className="kira-avatar-large">
                                                <img src={kra_icon} alt="Kira" onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = 'https://via.placeholder.com/100'
                                                }}/>
                                                <h3 className="welcome-heading">Hi, I'm Kira</h3>

                                            </div>}
                                            <div className="welcome-text">
                                                {walletAddress ? (
                                                    <>
                                                        <p className="welcome-subheading">How can I help you today?</p>
                                                    </>
                                                ) : (
                                                    <>
                                                        <p className="welcome-subheading">Please connect your wallet to
                                                            chat with me</p>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    messages.map(message => (
                                        <ChatMessage
                                            key={`${message.id}`}
                                            message={message}
                                        />
                                    ))
                                )}

                                {((loading || isTransactionPending)) && (
                                    <div className="thinking-message">
                                        <div className="ai-avatar">
                                            <img src="/kira.png" alt="Kira" onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = 'https://via.placeholder.com/30'
                                            }}/>
                                        </div>
                                        <div>{isTransactionPending ? "Processing transaction..." : "Thinking..."}</div>
                                    </div>
                                )}

                                <div ref={messagesEndRef}/>
                            </div>
                        </div>
                        <div className="chat-footer-outer-container">
                            <div className="chat-footer">
                                <div className="chat-footer-inner">
                                    {walletAddress && !hasVIPAccess && (
                                        <div style={{height: "0px"}}>
                                            <img src={no_vip_icon}
                                                 className="chat-footer-no-vip-icon"
                                                 alt="!"/>
                                        </div>
                                    )}
                                    {/* <form onSubmit={sendMessage} className="message-form"> */}
                                    <form onSubmit={sendMessageStreaming} className="message-form">
                                    <textarea
                                        ref={inputRef}
                                        className={`message-input ${isLeftPanelLoading}`}
                                        placeholder={
                                            !walletAddress
                                                ? "Connect your wallet first to chat with Kira"
                                                : !hasVIPAccess ?
                                                    "      Kira Chat requires Silver VIP status."
                                                    : isLeftPanelLoading
                                                        ? "Loading conversations..."
                                                        : "Message Kira"
                                        }
                                        value={inputText}
                                        onChange={(e) => setInputText(e.target.value)}
                                        onInput={autoGrow}
                                        // disabled={!walletAddress || loading || isTransactionPending}
                                        // @Chris: not sure delete loading will affect the code
                                        disabled={!hasVIPAccess || !walletAddress || isTransactionPending}

                                        style={{
                                            opacity: !walletAddress ? 0.5 : 1,
                                            cursor: !walletAddress ? 'not-allowed' : 'text',
                                            '--placeholder-color': !hasVIPAccess ? 'white' : '#8D8D8D'

                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' && !e.shiftKey) {
                                                e.preventDefault();
                                                sendMessageStreaming(e); // Trigger your send handler
                                            }
                                        }}
                                    />
                                    </form>
                                    <div className="message-form2">
                                        <img
                                            className="send-button"
                                            src={sendIsHovered && (!(isLeftPanelLoading || !walletAddress || !hasVIPAccess)) ? send_icon_hover : send_icon}
                                            alt="Send"
                                            onMouseEnter={() => {
                                                if (!(!walletAddress === null || isLeftPanelLoading || !hasVIPAccess)) {
                                                    setSendIsHovered(true);
                                                }
                                            }}
                                            onMouseLeave={() => {
                                                if (!(!walletAddress === null || isLeftPanelLoading || !hasVIPAccess)) {
                                                    setSendIsHovered(false);
                                                }
                                            }}
                                            onClick={sendMessageStreaming}
                                            style={{
                                                opacity: !walletAddress || isLeftPanelLoading || !hasVIPAccess ? 0.5 : 1,
                                                cursor: isLeftPanelLoading || !walletAddress || !hasVIPAccess ? 'not-allowed' : 'pointer',
                                                backgroundColor: sendIsHovered && !(isLeftPanelLoading || !walletAddress || !hasVIPAccess) ? '#FFFFFF' : '#343434'
                                            }}
                                        />
                                    </div>
                                </div>
                                {/* 只在桌面端显示的容器（ */}
                                <div className="action-buttons">
                                    <button
                                        className={`action-button mint ${isLeftPanelLoading ? styles.disabledButton : ''}`}
                                        onClick={handleMintButtonClick}
                                        disabled={!hasVIPAccess ||!walletAddress || loading || isLeftPanelLoading}
                                        style={{
                                            opacity: !walletAddress || isLeftPanelLoading ? 0.5 : 1,
                                            cursor: isLeftPanelLoading ? 'not-allowed' : 'pointer'
                                        }}
                                    >
                                        <img src={mint_icon}></img> Mint USDi
                                    </button>
                                    <button
                                        className={`action-button redeem ${isLeftPanelLoading ? styles.disabledButton : ''}`}
                                        onClick={handleRedeemButtonClick}
                                        disabled={!hasVIPAccess || !walletAddress || loading || isLeftPanelLoading}
                                        style={{
                                            opacity: !walletAddress || isLeftPanelLoading ? 0.5 : 1,
                                            cursor: isLeftPanelLoading ? 'not-allowed' : 'pointer'
                                        }}
                                    >
                                        <img src={redeem_icon}></img> Redeem USDi
                                    </button>
                                    <button
                                        className={`action-button network ${isLeftPanelLoading ? styles.disabledButton : ''}`}
                                        onClick={handleNetworkButtonClick}
                                        disabled={!hasVIPAccess || !walletAddress || loading || isLeftPanelLoading}
                                        style={{
                                            opacity: !walletAddress || isLeftPanelLoading ? 0.5 : 1,
                                            cursor: isLeftPanelLoading ? 'not-allowed' : 'pointer'
                                        }}
                                    >
                                        <img src={c2c_icon}></img> C2C Network
                                    </button>
                                </div>

                                {/* only showing in mobile */}
                                <div className="action-buttons-mobile">
                                    <div className="action-buttons-mobile-inner">

                                        <button
                                            className={`action-button-mobile mint ${isLeftPanelLoading ? styles.disabledButton : ''}`}
                                            onClick={handleMintButtonClick}
                                            disabled={!hasVIPAccess || !walletAddress || loading || isLeftPanelLoading}
                                            style={{
                                                opacity: !walletAddress || isLeftPanelLoading ? 0.5 : 1,
                                                cursor: isLeftPanelLoading ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            <img src={mint_icon} alt="Mint"/>
                                        </button>
                                        <button
                                            className={`action-button-mobile redeem ${isLeftPanelLoading ? styles.disabledButton : ''}`}
                                            onClick={handleRedeemButtonClick}
                                            disabled={!hasVIPAccess  || !walletAddress || loading || isLeftPanelLoading}
                                            style={{
                                                opacity: !walletAddress || isLeftPanelLoading ? 0.5 : 1,
                                                cursor: isLeftPanelLoading ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            <img src={redeem_icon} alt="Redeem"/>
                                        </button>
                                        <button
                                            className={`action-button-mobile network ${isLeftPanelLoading ? styles.disabledButton : ''}`}
                                            onClick={handleNetworkButtonClick}
                                            disabled={!hasVIPAccess  || !walletAddress || loading || isLeftPanelLoading}
                                            style={{
                                                opacity: !walletAddress || isLeftPanelLoading ? 0.5 : 1,
                                                cursor: isLeftPanelLoading ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            <img src={c2c_icon} alt="C2C"/>
                                        </button>
                                    </div>
                                </div>
                                {!hasVIPAccess && walletAddress && (
                                    <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                                        <button
                                            className="kira-joinVIPButton"
                                            style={{marginTop: '78px'}}
                                            onClick={handleJoinVipClick}
                                        >
                                            Join the Silver VIP club now.
                                        </button>
                                    </div>)}


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};


export default KiraAI;